/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import { connect } from 'react-redux'
import React, { Component } from 'react'
import { withRouter } from 'react-router'

import passwordValidator from 'password-validator'

import './MemberSetupContainer.css'
import {PRIVACY_POLICY, TERMS_OF_USE} from '../../../util/links'
import TopBar from '../components/TopBar'
import {webApi} from '../../../lib/WebApi'
import {fullName2FirstLast} from '../../../util/helpers'
import {statAdminEvent} from '../../../util/analytics'
import * as localForage from 'localforage'

import { TRCButton, TRCInput } from '../../../trace'

class TeamMemberSetup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: [],
            editState: { fullName: '', password: '', password2: ''},
            inviteInfo: null,
            team: null
        }

        this.onCompleteSetup = this.onCompleteSetup.bind(this)
        this.onPassword2Changed = this.onPassword2Changed.bind(this)
        this.onPasswordChanged = this.onPasswordChanged.bind(this)
        this.onUserFullNameChanged = this.onUserFullNameChanged.bind(this)
        this.validator = new passwordValidator()
        this.validator.is().min(6).has().lowercase()
    }

    caption(field, text) {
        const errors = this.state.errors
        if(!field) {
            if(errors.length > 0) return errors[0].error
            return ''
        }
        for(const error of errors) {
            if (error.field === field) {
                return error.error
            }
        }
        return text
    }

    errorClass(field) {
        const errors = this.state.errors
        if(!field && errors.length > 0) return 'error'
        for(const error of errors) {
            if (error.field === field) {
                return 'invalid'
            }
        }
        return ''
    }

    errorWithout(field) {
        let err = []
        for(const item of this.state.errors) {
            if(item.field !== field) {
                err.push(item)
            }
        }
        return err
    }

    shortenName(full) {
        if(!full) return ''
        if(full.length < 14) return full
        return `${full.substr(0,6)}...${full.substr(-6,6)}`
    }

    componentWillMount() {
        const wthis = this
        webApi.getTeamInviteInfo(this.props.inviteId).then(data => {
            if(data) {
                if (!data.is_new_user) {
                    const state = wthis.state.editState
                    wthis.setState({
                        inviteInfo: data,
                        editState: Object.assign(state, {fullName: `${data.first_name} ${data.last_name}`})
                    })
                } else {
                    wthis.setState({inviteInfo: data})
                }
            }
        })
    }

    componentWillReceiveProps(nextProps) {
    }

    render() {
        const editState = this.state.editState
        let disabled = false
        let hiddenClass = ''
        if(this.state.inviteInfo && !this.state.inviteInfo.is_new_user) {
            disabled = true
            hiddenClass = 'hidden'
        }

        return (
            <div className="MemberSetup">
                <TopBar/>
                <div className="trace-container content">
                    <h1>Complete setup</h1>
                    <span>
                        Please accept your invitation below.
                    </span>

                    {hiddenClass && (<span>Seems like you already have an account, please, enter your password to confirm.</span>)}

                    <div className="areablock">
                        <h4>Your Full Name</h4>
                        <TRCInput
                            full
                            type="text"
                            placeholder="Enter Full Name"
                            value={editState.fullName}
                            onChange={this.onUserFullNameChanged}
                            disabled={disabled}
                            error={this.caption('fullName')}
                        />
                    </div>

                    <div className={`areablock ${hiddenClass}`}>
                        <h4>Your password</h4>
                        <TRCInput
                            full
                            type="password"
                            placeholder="Enter Desired Password"
                            value={editState.password}
                            onChange={this.onPasswordChanged}
                            error={this.caption('password')}
                        />
                        <TRCInput
                            full
                            type="password"
                            placeholder="Re-enter Password"
                            value={editState.password2}
                            onChange={this.onPassword2Changed}
                            error={this.caption('password')}
                        />
                    </div>

                    <div className={`areablock ${hiddenClass ? '' : 'hidden'}`}>
                        <h4>Your password</h4>
                        <TRCInput
                            full
                            type="password"
                            placeholder="Enter Your Current Password"
                            value={editState.password}
                            onChange={this.onPasswordChanged}
                            error={this.caption('password')}
                        />
                        <div>
                            <a className="trace-input ghost" style={{margin: 0, textAlign: 'unset'}} href="http://soccer.traceup.com/account/send_password_restoration_email">Forgot password?</a>
                        </div>
                    </div>

                    <div className="bottom-buttons">
                        <TRCButton full onClick={this.onCompleteSetup}>
                          Accept
                        </TRCButton>
                    </div>

                    <div className="subscript">By signing up you agree to our <a href={TERMS_OF_USE}>Terms of Service</a> and <a href={PRIVACY_POLICY}>Privacy Policy</a></div>
                </div>
            </div>
        )
    }

    onUserFullNameChanged(e) {
        const state = Object.assign({}, this.state.editState, {fullName: e})
        this.setState({editState: state, errors: this.errorWithout('fullName')})
    }

    onPasswordChanged(e) {
        const state = Object.assign({}, this.state.editState, {password: e})
        this.setState({editState: state, errors: this.errorWithout('password')})
    }

    onPassword2Changed(e) {
        const state = Object.assign({}, this.state.editState, {password2: e})
        this.setState({editState: state, errors: this.errorWithout('password2')})
    }

    onCompleteSetup(e) {
        e.preventDefault()
        let errors = []
        const state = this.state.editState

        if(!this.state.inviteInfo) {
            errors.push({field: 'fullName', error: 'Sorry, your invitation is no longer valid'})
        } else
        if(this.state.inviteInfo.is_new_user) {
            if (state.fullName.trim().length < 4) {
                errors.push({field: 'fullName', error: 'Name is too short, please enter full name'})
            }
            if (state.password !== state.password2) {
                errors.push({
                    field: 'password',
                    error: 'Passwords don\'t match, Enter the same password in both fields.'
                })
                errors.push({field: 'password2', error: ''})
            }
        }

        const ret = this.validator.validate(state.password, {list: true})
        console.log('Password validation: ' + ret)
        if (ret.length > 0) {
            if (ret.includes('min')) {
                errors.push({
                    field: 'password',
                    error: 'Password is too short (6 letters min)'
                })
            }
            if (ret.includes('lowercase')) {
                errors.push({
                    field: 'password',
                    error: 'Password should contain at least one letter [a-z]'
                })
            }
        }

        this.setState({errors: errors})
        const self = this
        if(errors.length === 0) {

            let data = { invite_code: this.props.inviteCode, password: state.password}
            if(this.state.inviteInfo.is_new_user) {
                data = Object.assign(data, fullName2FirstLast(state.fullName))
            }

            webApi.acceptTeamInvite(this.props.inviteId, data)
                .then(() => {
                    statAdminEvent('0', 'accept-team-invite', 'coach')

                    console.log('current_team_id', this.props.match.params.team_id)
                    localForage.setItem('current_team_id', this.props.match.params.team_id)

                    this.props.history.replace(`/invite/${this.props.inviteId}/${this.props.inviteCode}/division/0/fieldapp/coach`)
                })
                .then(() => {

                })
                .catch(() => {
                    console.log('something went wrong while accepting the invitation')
                    errors.push({
                        field: 'password',
                        error: 'Probably your password is incorrect'
                    })
                    self.setState({errors: errors})
                })
        }
    }
}

const mapStateToProps = (state, props) => {
    const teamId = props.match.params.team_id
    const inviteId = props.match.params.invite_id
    const inviteCode = props.match.params.invite_code
    const userId = props.match.params.user_id
    return {
        teamId,
        inviteId,
        inviteCode,
        userId
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

const TeamMemberSetupContainer = withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(TeamMemberSetup))

export default TeamMemberSetupContainer
